import { CLIENT_DOMAIN } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice } from '../services';
import { constants } from '../constant/constant';

export const getClientDomainList = (clientId) => (dispatch) => {
  const query = `${constants.API.CLIENT_DOMAIN}/${clientId}`;

  dispatch({
    payload: [],
    type: CLIENT_DOMAIN.GET.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];
      let count = 0;

      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      const responseData = rows && rows.length ? rows.map((data) => (
        {
          ...data,
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          created_at: dateFormat(data.createdAt),
        }
      )) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: CLIENT_DOMAIN.DATA.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT_DOMAIN.DATA.ERROR,
      });
    });
};

export const doClientDomainCreate = (data) => httpservice()
  .post(`${constants.API.CLIENT_DOMAIN}`, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doClientDomainUpdate = (params, formData) => httpservice()
  .put(`${constants.API.CLIENT_DOMAIN}/${params.clientId}/${params.id}`, formData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doClientDomainDelete = (id, clientId) => httpservice()
  .delete(`${constants.API.CLIENT_DOMAIN}/${clientId}/${id}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);
